"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress/CircularProgress.js"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _makeStyles.default)(theme => ({
  parent: {
    position: 'relative',
    height: '100%'
  },
  cover: {
    position: p => p.isCover ? 'absolute' : 'inherit',
    left: '0px',
    right: '0px',
    height: '100%',
    backgroundColor: p => p.isCover && !p.hideCover ? '#ffffffbb' : 'inherit',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  spinnerColor: {
    color: theme.palette.text.primary
  }
}));
/** Loading spinner that centers in container with opaque cover if children are provided */
function Spinner({
  show = true,
  hideCover,
  coverOverride,
  children,
  className,
  ...rest
}, ref) {
  const classes = useStyles({
    isCover: Boolean(children),
    hideCover
  });
  const cover = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: classes.cover,
    ref: ref,
    children: coverOverride ? coverOverride : /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress.default, {
      className: classes.spinnerColor,
      ...rest
    })
  });
  return children ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames.default)(classes.parent, className),
    children: [show && cover, children]
  }) : show ? cover : null;
}
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(Spinner);